import React, { useEffect, useState } from 'react';
import { XIcon, GiftIcon, ZapIcon } from 'lucide-react';
const PURCHASE_URL = 'https://servicios-juridicos-2.myshopify.com/cart/51819904270567:1';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    let shown = false;
    const show = () => {
      if (!shown) {
        shown = true;
        setIsVisible(true);
      }
    };
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
      show();
    };
    // Push extra history entry so first Back press triggers popstate
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/85 backdrop-blur-md" data-id="element-481">
      <div className="relative bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-black rounded-3xl shadow-[0_0_60px_rgba(34,197,94,0.45)] max-w-lg w-full overflow-hidden border border-green-500/50" data-id="element-482">
        {/* Neon glows */}
        <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-40 bg-green-500/25 rounded-full blur-3xl pointer-events-none" data-id="element-483" />
        <div className="absolute -bottom-16 -right-10 w-56 h-56 bg-yellow-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-484" />

        {/* Top accent bar */}
        <div className="h-1.5 bg-gradient-to-r from-green-400 via-green-500 to-green-400 w-full shadow-[0_0_15px_rgba(34,197,94,0.8)]" data-id="element-485" />

        {/* Close button */}
        <button onClick={() => setIsVisible(false)} className="absolute top-4 right-4 text-slate-500 hover:text-white transition-colors z-10" aria-label="Cerrar" data-id="element-486">
          <XIcon className="h-6 w-6" data-id="element-487" />
        </button>

        <div className="p-8 relative z-10" data-id="element-488">
          {/* Icon */}
          <div className="flex justify-center mb-5" data-id="element-489">
            <div className="relative" data-id="element-490">
              <div className="absolute inset-0 bg-green-500/40 rounded-full blur-xl scale-150" data-id="element-491" />
              <div className="relative bg-gradient-to-br from-green-400 to-green-600 rounded-2xl p-4 shadow-[0_0_30px_rgba(34,197,94,0.6)] border border-green-300/40" data-id="element-492">
                <GiftIcon className="h-9 w-9 text-white drop-shadow-lg" data-id="element-493" />
              </div>
            </div>
          </div>

          {/* Headline */}
          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-4 leading-tight uppercase drop-shadow-[0_0_15px_rgba(255,255,255,0.15)]" data-id="element-494">
            ¡Espera! No te vayas todavía 🚨
          </h2>

          {/* Body */}
          <p className="text-slate-300 text-center mb-3 text-base leading-relaxed" data-id="element-495">
            Si llegaste hasta acá, es porque{' '}
            <span className="font-bold text-white" data-id="element-496">
              sentís la necesidad de mejorar y dar un salto real en tu carrera.
            </span>
          </p>
          <p className="text-slate-300 text-center mb-5 text-base leading-relaxed" data-id="element-497">
            Por eso, antes de que te vayas, queremos darte un{' '}
            <span className="font-black text-transparent bg-clip-text bg-gradient-to-r from-green-300 to-green-500" data-id="element-498">
              descuento exclusivo del 15%
            </span>{' '}
            en el Megapack Jurídico 2026.
          </p>

          {/* Auto-apply notice */}
          <div className="bg-green-500/10 border border-green-500/40 rounded-xl p-4 mb-6 flex items-start gap-3 shadow-[0_0_20px_rgba(34,197,94,0.12)]" data-id="element-499">
            <ZapIcon className="h-5 w-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-500" />
            <p className="text-sm text-green-200 font-semibold text-left" data-id="element-501">
              Al presionar el botón, el descuento del 15% se aplica
              automáticamente en tu carrito. ¡Sin códigos ni pasos extra!
            </p>
          </div>

          {/* CTA Button */}
          <a href={PURCHASE_URL} onClick={() => setIsVisible(false)} className="block w-full bg-gradient-to-r from-green-500 to-green-600 text-white font-black text-lg md:text-xl py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_50px_rgba(34,197,94,0.6)] transform hover:scale-105 transition-all duration-300 text-center uppercase border-2 border-green-400" data-id="element-502">
            QUIERO MI MEGAPACK
          </a>

          {/* Dismiss link */}
          <button onClick={() => setIsVisible(false)} className="block w-full text-center text-sm text-slate-500 hover:text-slate-300 mt-4 transition-colors" data-id="element-503">
            No, prefiero pagar precio completo
          </button>
        </div>
      </div>
    </div>;
}